export default "__VITE_ASSET__BYjkXKJ7__"